import React from "react";

type ArrowForwardProps = Partial<{
  className: string;
  fill: string;
}>;

export const ArrowForwardIcon = ({
  className,
  fill = "#D6D6D6",
}: ArrowForwardProps): React.ReactElement => {
  return (
    <svg
      id="arrow-forward"
      className={className}
      width="9"
      height="18"
      viewBox="0 0 9 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
    >
      <path
        d="M1.295 0.249512L7.836 9.00051L1 17.7505"
        stroke={fill}
        strokeWidth="0.5"
      />
    </svg>
  );
};
